module.exports = {"attributes":{"viewBox":"0 0 200 200","xmlns":"http://www.w3.org/2000/svg"},"content":"<text class='channel-icon-logo' style=\"white-space: pre; font-family: Arial, sans-serif; font-weight: 700; font-size: 160px;\" x=\"-8.765\" y=\"162.959\" transform=\"matrix(0.89892, 0, 0, 0.987499, 3.007254, -7.553823)\">IH</text>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/channel/type_in_house.svg
// module id = 1371
// module chunks = 0